module.exports = __webpack_public_path__ + "img/free.df97f028.png";